import { render, staticRenderFns } from "./AddTiktok.vue?vue&type=template&id=df05920c"
import script from "./AddTiktok.vue?vue&type=script&lang=js"
export * from "./AddTiktok.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports